module.exports = __webpack_public_path__ + "img/ship.c6676beb.svg";